import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAuthError = error => ({
  type: actionTypes.SET_AUTH_ERROR,
  payload: error
})
